
import { Reducer } from 'redux';
import { SET_VIEW_MODE, SET_WELCOME_SCREEN_SHOWN } from '../actions/uiActions'

const defaultState = {
    viewMode: 'CONSUMER',
    welcomeScreenShown: false,
};

const uiReducer: Reducer = (
    previousState = defaultState,
    action
) => {
    switch (action.type) {
        case SET_VIEW_MODE:
            return {
                ...previousState,
                viewMode: action.payload,
            };
        case SET_WELCOME_SCREEN_SHOWN:
                return {
                    ...previousState,
                    welcomeScreenShown: action.payload,
                };
        default:
            return previousState;
    }
}

export default uiReducer;